import React from "react";
import ReactDOM from "react-dom";
import PortalReactDOM from "react-dom";
import { MathJax, MathJaxContext } from "better-react-mathjax";

import '../../assets/css/post.css'
import ReactHtmlParser from 'html-react-parser';


// const extractCodeContent = (htmlString) => {
//     const parser = new DOMParser();
//     const htmlFromString = parser.parseFromString(htmlString, 'text/html');
//     const codeTags = htmlFromString.querySelectorAll('code');
//     return Array.from(codeTags).map((el) => el.textContent);
//   };
  
//   const copyText = async (text) => {
//     try {
//       await navigator.clipboard.writeText(text);
//     } catch (err) {
//       console.log(err);
//       throw Error('Failed to copy');
//     }
//   };
  
//   const replace = (domNode) => {
//     if (
//       domNode.name === 'button' &&
//       domNode.attribs.id?.startsWith('copy_button_')
//       // Id bắt đầu bằng testButton_, số đầu là 0 (testButton_0)
//     ) {
//       const buttonIndex = parseInt(domNode.attribs.id.split('_')[2], 10);
//       console.log(domNode.attribs.id.split('_')[2])
//       return (
//         <button onClick={() => handleCopy(buttonIndex)}>
//           {domNode.children[0]?.data || 'Button'}
//         </button>
//       );
//     }
//   };

//     const handleCopy = async (step) => {
//     try {
//       const insideCodeTag = extractCodeContent(html)[step];
//       console.log(insideCodeTag);
//       await copyText(insideCodeTag);
//       // setStatus(`Step ${step + 1} Copied!`);
//     } catch (error) {
//       // setStatus(error.message);
//       console.log("error copy")
//     }
//   };

const ReviewModal = ({ isShowing, hide, content, imageURL }) =>
  isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
            <>  
   <script type="text/javascript" id="MathJax-script" async
      src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js">
    window.MathJax.startup.defaultReady();
    </script>      
              <div className="custom-modal-overlay" />
          <div
          style={{
            "width": "100vw",
            "height": "100vh",
            "position": "fixed",
            "top": "40px",
            "left": "0",
            "zIndex": "1040"
          }}    
            className="custom-modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="custom-modal"
                style={{
                "top": "20vh", 
                "zIndex": "100",
                "background": "rgb(202, 202, 202)",
                "position": "relative",
                "margin": "1.75rem auto",
                "maxWidth": "1000px",
                /* padding: 2rem; */
                "opacity": "1!important",
                }}
            >
              <div className="custom-modal-header">
                <button
                  type="button"
                  className="modal-close-button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={hide}
                  style={{
                    width: "fit-content",
                    padding: 0,
                    marginTop: "5px",
                    marginRight: "5px",
                  }}
                >
                  {/* <span
                    style={{
                      fontSize: "32px",
                      fontWeight: "bold",
                      color: "black",
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                    aria-hidden="true"
                  >
                    &times;
                  </span> */}
                  {/* close */}
                  <svg
                    width="20"
                    height="20"
                    viewPort="0 0 12 12"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ backgroundColor: "transparent" }}
                  >
                    <line
                      x1="1"
                      y1="19"
                      x2="19"
                      y2="1"
                      stroke="black"
                      stroke-width="2"
                    />
                    <line
                      x1="1"
                      y1="1"
                      x2="19"
                      y2="19"
                      stroke="black"
                      stroke-width="2"
                    />
                  </svg>
                </button>
              </div>
              <div className="custom-model-content"
              style={{
                "backgroundColor": "white"
              }}>
               {/* ReactHtmlParser("") */}
               <>
                {ReactHtmlParser(content)}
               </>
              </div>
            </div>
          </div>
          </>
        </React.Fragment>,
        document.body
      )
    : null;

export default ReviewModal;
